<template>
  <a-modal
    :visible="visible"
    title="驳回"
    :confirm-loading="isConfirmCloseBtnLading"
    @ok="handleReject"
    @cancel="handleCancelClose"
  >
    <a-textarea placeholder="请填写" v-model="closeReason" :maxLength="50" :auto-size="{ minRows: 3, maxRows: 6 }" />
  </a-modal>
</template>

<script>
import { apiAuditPurchasePlanPool } from '@/api/scp/month-plan-pool/month-plan-pool';
import { PLAN_STATUS } from '../common';
export default {
  name: 'RejectModal',
  props: {
    mainBtnLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      visible: false,
      isConfirmCloseBtnLading: false,
      closeReason: '',
      selectedRowList: [] // 勾选的数据
    }
  },
  methods: {
    show (params) {
      this.selectedRowList = params;
      this.visible = true
      this.closeReason = ''
    },
    // 驳回
    handleReject () {
      if (!this.closeReason) {
        this.$message.warning('请填写驳回原因')
        return
      }
      this.isConfirmCloseBtnLading = true
      this.$emit('update:mainBtnLoading', true);
      apiAuditPurchasePlanPool({
        ids: this.selectedRowList.map(item => item.id),
        status: PLAN_STATUS.CREATE.lookupCode,
        auditRemark: this.closeReason
      }).then(res => {
        if (res?.code === 200) {
          this.$message.success('操作成功!')
          this.$emit('successCall')
          this.visible = false
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
        this.isConfirmCloseBtnLading = false
        this.$emit('update:mainBtnLoading', false);
      })
    },
    // 取消
    handleCancelClose () {
      this.visible = false
      this.closeReason = ''
    }
  }
}
</script>

<style scoped>

</style>
